"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemoveAddressMutation = exports.RemoveAddressDocument = exports.useBalancesLazyQuery = exports.useBalancesQuery = exports.BalancesDocument = exports.useXyoBalanceLazyQuery = exports.useXyoBalanceQuery = exports.XyoBalanceDocument = exports.useEthereumBalanceLazyQuery = exports.useEthereumBalanceQuery = exports.EthereumBalanceDocument = exports.useContractBalanceLazyQuery = exports.useContractBalanceQuery = exports.ContractBalanceDocument = exports.useTagAddressMutation = exports.TagAddressDocument = exports.useVerifyAddressMutation = exports.VerifyAddressDocument = exports.useUserVerifiedAddressesWithBalancesLazyQuery = exports.useUserVerifiedAddressesWithBalancesQuery = exports.UserVerifiedAddressesWithBalancesDocument = exports.useUserVerifiedAddressesLazyQuery = exports.useUserVerifiedAddressesQuery = exports.UserVerifiedAddressesDocument = exports.useMyVerifiedAddressesWithTokenAndPairBalancesLazyQuery = exports.useMyVerifiedAddressesWithTokenAndPairBalancesQuery = exports.MyVerifiedAddressesWithTokenAndPairBalancesDocument = exports.useMyVerifiedAddressesWithBalancesLazyQuery = exports.useMyVerifiedAddressesWithBalancesQuery = exports.MyVerifiedAddressesWithBalancesDocument = exports.useMyVerifiedAddressesLazyQuery = exports.useMyVerifiedAddressesQuery = exports.MyVerifiedAddressesDocument = exports.useIsVerifiedAddressLazyQuery = exports.useIsVerifiedAddressQuery = exports.IsVerifiedAddressDocument = exports.VerifiedAddressFragmentDoc = exports.VerifyType = exports.Unit = void 0;
var client_1 = require("@apollo/client");
var Apollo = __importStar(require("@apollo/client"));
var defaultOptions = {};
var Unit;
(function (Unit) {
    Unit["Noether"] = "noether";
    Unit["Wei"] = "wei";
    Unit["Kwei"] = "kwei";
    Unit["Babbage"] = "babbage";
    Unit["Femtoether"] = "femtoether";
    Unit["Mwei"] = "mwei";
    Unit["Lovelace"] = "lovelace";
    Unit["Picoether"] = "picoether";
    Unit["Gwei"] = "gwei";
    Unit["Shannon"] = "shannon";
    Unit["Nanoether"] = "nanoether";
    Unit["Nano"] = "nano";
    Unit["Szabo"] = "szabo";
    Unit["Microether"] = "microether";
    Unit["Micro"] = "micro";
    Unit["Finney"] = "finney";
    Unit["Milliether"] = "milliether";
    Unit["Milli"] = "milli";
    Unit["Ether"] = "ether";
    Unit["Kether"] = "kether";
    Unit["Grand"] = "grand";
    Unit["Mether"] = "mether";
    Unit["Gether"] = "gether";
    Unit["Tether"] = "tether";
})(Unit = exports.Unit || (exports.Unit = {}));
var VerifyType;
(function (VerifyType) {
    VerifyType["Sign"] = "sign";
    VerifyType["SignType"] = "signType";
    VerifyType["SignTypeV3"] = "signTypeV3";
})(VerifyType = exports.VerifyType || (exports.VerifyType = {}));
exports.VerifiedAddressFragmentDoc = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment VerifiedAddress on VerifiedAddress {\n  id\n  uid\n  type\n  address\n  signature\n  name\n  notes\n  fhr {\n    uid\n    total\n    balance\n    hasSold\n  }\n}\n    "], ["\n    fragment VerifiedAddress on VerifiedAddress {\n  id\n  uid\n  type\n  address\n  signature\n  name\n  notes\n  fhr {\n    uid\n    total\n    balance\n    hasSold\n  }\n}\n    "])));
exports.IsVerifiedAddressDocument = client_1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    query IsVerifiedAddress($address: String!) {\n  isVerifiedAddress(address: $address)\n}\n    "], ["\n    query IsVerifiedAddress($address: String!) {\n  isVerifiedAddress(address: $address)\n}\n    "])));
/**
 * __useIsVerifiedAddressQuery__
 *
 * To run a query within a React component, call `useIsVerifiedAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsVerifiedAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsVerifiedAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
function useIsVerifiedAddressQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.IsVerifiedAddressDocument, options);
}
exports.useIsVerifiedAddressQuery = useIsVerifiedAddressQuery;
function useIsVerifiedAddressLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.IsVerifiedAddressDocument, options);
}
exports.useIsVerifiedAddressLazyQuery = useIsVerifiedAddressLazyQuery;
exports.MyVerifiedAddressesDocument = client_1.gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    query MyVerifiedAddresses {\n  verifiedAddresses {\n    ...VerifiedAddress\n  }\n}\n    ", ""], ["\n    query MyVerifiedAddresses {\n  verifiedAddresses {\n    ...VerifiedAddress\n  }\n}\n    ", ""])), exports.VerifiedAddressFragmentDoc);
/**
 * __useMyVerifiedAddressesQuery__
 *
 * To run a query within a React component, call `useMyVerifiedAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyVerifiedAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyVerifiedAddressesQuery({
 *   variables: {
 *   },
 * });
 */
function useMyVerifiedAddressesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.MyVerifiedAddressesDocument, options);
}
exports.useMyVerifiedAddressesQuery = useMyVerifiedAddressesQuery;
function useMyVerifiedAddressesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.MyVerifiedAddressesDocument, options);
}
exports.useMyVerifiedAddressesLazyQuery = useMyVerifiedAddressesLazyQuery;
exports.MyVerifiedAddressesWithBalancesDocument = client_1.gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    query MyVerifiedAddressesWithBalances {\n  verifiedAddresses {\n    ...VerifiedAddress\n    ethBalance(unit: ether)\n    xyoBalance: contractBalance(\n      unit: ether\n      contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    )\n  }\n}\n    ", ""], ["\n    query MyVerifiedAddressesWithBalances {\n  verifiedAddresses {\n    ...VerifiedAddress\n    ethBalance(unit: ether)\n    xyoBalance: contractBalance(\n      unit: ether\n      contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    )\n  }\n}\n    ", ""])), exports.VerifiedAddressFragmentDoc);
/**
 * __useMyVerifiedAddressesWithBalancesQuery__
 *
 * To run a query within a React component, call `useMyVerifiedAddressesWithBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyVerifiedAddressesWithBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyVerifiedAddressesWithBalancesQuery({
 *   variables: {
 *   },
 * });
 */
function useMyVerifiedAddressesWithBalancesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.MyVerifiedAddressesWithBalancesDocument, options);
}
exports.useMyVerifiedAddressesWithBalancesQuery = useMyVerifiedAddressesWithBalancesQuery;
function useMyVerifiedAddressesWithBalancesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.MyVerifiedAddressesWithBalancesDocument, options);
}
exports.useMyVerifiedAddressesWithBalancesLazyQuery = useMyVerifiedAddressesWithBalancesLazyQuery;
exports.MyVerifiedAddressesWithTokenAndPairBalancesDocument = client_1.gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    query MyVerifiedAddressesWithTokenAndPairBalances {\n  verifiedAddresses {\n    ...VerifiedAddress\n    ethBalance(unit: ether)\n    xyoBalance: contractBalance(\n      unit: ether\n      contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    )\n    xyoLpBalance: contractBalance(\n      unit: ether\n      contractAddress: \"0xa986f2a12d85c44429f574ba50c0e21052b18ba1\"\n    )\n  }\n}\n    ", ""], ["\n    query MyVerifiedAddressesWithTokenAndPairBalances {\n  verifiedAddresses {\n    ...VerifiedAddress\n    ethBalance(unit: ether)\n    xyoBalance: contractBalance(\n      unit: ether\n      contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    )\n    xyoLpBalance: contractBalance(\n      unit: ether\n      contractAddress: \"0xa986f2a12d85c44429f574ba50c0e21052b18ba1\"\n    )\n  }\n}\n    ", ""])), exports.VerifiedAddressFragmentDoc);
/**
 * __useMyVerifiedAddressesWithTokenAndPairBalancesQuery__
 *
 * To run a query within a React component, call `useMyVerifiedAddressesWithTokenAndPairBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyVerifiedAddressesWithTokenAndPairBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyVerifiedAddressesWithTokenAndPairBalancesQuery({
 *   variables: {
 *   },
 * });
 */
function useMyVerifiedAddressesWithTokenAndPairBalancesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.MyVerifiedAddressesWithTokenAndPairBalancesDocument, options);
}
exports.useMyVerifiedAddressesWithTokenAndPairBalancesQuery = useMyVerifiedAddressesWithTokenAndPairBalancesQuery;
function useMyVerifiedAddressesWithTokenAndPairBalancesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.MyVerifiedAddressesWithTokenAndPairBalancesDocument, options);
}
exports.useMyVerifiedAddressesWithTokenAndPairBalancesLazyQuery = useMyVerifiedAddressesWithTokenAndPairBalancesLazyQuery;
exports.UserVerifiedAddressesDocument = client_1.gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    query UserVerifiedAddresses($uid: String!) {\n  userVerifiedAddresses(uid: $uid) {\n    ...VerifiedAddress\n  }\n}\n    ", ""], ["\n    query UserVerifiedAddresses($uid: String!) {\n  userVerifiedAddresses(uid: $uid) {\n    ...VerifiedAddress\n  }\n}\n    ", ""])), exports.VerifiedAddressFragmentDoc);
/**
 * __useUserVerifiedAddressesQuery__
 *
 * To run a query within a React component, call `useUserVerifiedAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserVerifiedAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserVerifiedAddressesQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
function useUserVerifiedAddressesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.UserVerifiedAddressesDocument, options);
}
exports.useUserVerifiedAddressesQuery = useUserVerifiedAddressesQuery;
function useUserVerifiedAddressesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.UserVerifiedAddressesDocument, options);
}
exports.useUserVerifiedAddressesLazyQuery = useUserVerifiedAddressesLazyQuery;
exports.UserVerifiedAddressesWithBalancesDocument = client_1.gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    query UserVerifiedAddressesWithBalances($uid: String!) {\n  userVerifiedAddresses(uid: $uid) {\n    ...VerifiedAddress\n    ethBalance(unit: ether)\n    xyoBalance: contractBalance(\n      unit: ether\n      contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    )\n  }\n}\n    ", ""], ["\n    query UserVerifiedAddressesWithBalances($uid: String!) {\n  userVerifiedAddresses(uid: $uid) {\n    ...VerifiedAddress\n    ethBalance(unit: ether)\n    xyoBalance: contractBalance(\n      unit: ether\n      contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    )\n  }\n}\n    ", ""])), exports.VerifiedAddressFragmentDoc);
/**
 * __useUserVerifiedAddressesWithBalancesQuery__
 *
 * To run a query within a React component, call `useUserVerifiedAddressesWithBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserVerifiedAddressesWithBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserVerifiedAddressesWithBalancesQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
function useUserVerifiedAddressesWithBalancesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.UserVerifiedAddressesWithBalancesDocument, options);
}
exports.useUserVerifiedAddressesWithBalancesQuery = useUserVerifiedAddressesWithBalancesQuery;
function useUserVerifiedAddressesWithBalancesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.UserVerifiedAddressesWithBalancesDocument, options);
}
exports.useUserVerifiedAddressesWithBalancesLazyQuery = useUserVerifiedAddressesWithBalancesLazyQuery;
exports.VerifyAddressDocument = client_1.gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    mutation VerifyAddress($address: String!, $signature: String!, $type: VerifyType!, $data: JSON!) {\n  verifyAddress(\n    address: $address\n    signature: $signature\n    type: $type\n    data: $data\n  ) {\n    ...VerifiedAddress\n  }\n}\n    ", ""], ["\n    mutation VerifyAddress($address: String!, $signature: String!, $type: VerifyType!, $data: JSON!) {\n  verifyAddress(\n    address: $address\n    signature: $signature\n    type: $type\n    data: $data\n  ) {\n    ...VerifiedAddress\n  }\n}\n    ", ""])), exports.VerifiedAddressFragmentDoc);
/**
 * __useVerifyAddressMutation__
 *
 * To run a mutation, you first call `useVerifyAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAddressMutation, { data, loading, error }] = useVerifyAddressMutation({
 *   variables: {
 *      address: // value for 'address'
 *      signature: // value for 'signature'
 *      type: // value for 'type'
 *      data: // value for 'data'
 *   },
 * });
 */
function useVerifyAddressMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.VerifyAddressDocument, options);
}
exports.useVerifyAddressMutation = useVerifyAddressMutation;
exports.TagAddressDocument = client_1.gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    mutation TagAddress($id: String!, $name: String, $notes: String) {\n  tag: updateAddress(id: $id, name: $name, notes: $notes) {\n    id\n    name\n    notes\n    address\n  }\n}\n    "], ["\n    mutation TagAddress($id: String!, $name: String, $notes: String) {\n  tag: updateAddress(id: $id, name: $name, notes: $notes) {\n    id\n    name\n    notes\n    address\n  }\n}\n    "])));
/**
 * __useTagAddressMutation__
 *
 * To run a mutation, you first call `useTagAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagAddressMutation, { data, loading, error }] = useTagAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *   },
 * });
 */
function useTagAddressMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.TagAddressDocument, options);
}
exports.useTagAddressMutation = useTagAddressMutation;
exports.ContractBalanceDocument = client_1.gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    query ContractBalance($contractAddress: String!, $address: String!, $unit: Unit) {\n  balance(contractAddress: $contractAddress, address: $address, unit: $unit)\n}\n    "], ["\n    query ContractBalance($contractAddress: String!, $address: String!, $unit: Unit) {\n  balance(contractAddress: $contractAddress, address: $address, unit: $unit)\n}\n    "])));
/**
 * __useContractBalanceQuery__
 *
 * To run a query within a React component, call `useContractBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractBalanceQuery({
 *   variables: {
 *      contractAddress: // value for 'contractAddress'
 *      address: // value for 'address'
 *      unit: // value for 'unit'
 *   },
 * });
 */
function useContractBalanceQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.ContractBalanceDocument, options);
}
exports.useContractBalanceQuery = useContractBalanceQuery;
function useContractBalanceLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.ContractBalanceDocument, options);
}
exports.useContractBalanceLazyQuery = useContractBalanceLazyQuery;
exports.EthereumBalanceDocument = client_1.gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    query EthereumBalance($address: String!, $unit: Unit) {\n  ethereum: balance(address: $address, unit: $unit)\n}\n    "], ["\n    query EthereumBalance($address: String!, $unit: Unit) {\n  ethereum: balance(address: $address, unit: $unit)\n}\n    "])));
/**
 * __useEthereumBalanceQuery__
 *
 * To run a query within a React component, call `useEthereumBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEthereumBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEthereumBalanceQuery({
 *   variables: {
 *      address: // value for 'address'
 *      unit: // value for 'unit'
 *   },
 * });
 */
function useEthereumBalanceQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.EthereumBalanceDocument, options);
}
exports.useEthereumBalanceQuery = useEthereumBalanceQuery;
function useEthereumBalanceLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.EthereumBalanceDocument, options);
}
exports.useEthereumBalanceLazyQuery = useEthereumBalanceLazyQuery;
exports.XyoBalanceDocument = client_1.gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    query XYOBalance($address: String!, $unit: Unit) {\n  xyo: balance(\n    contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    address: $address\n    unit: $unit\n  )\n}\n    "], ["\n    query XYOBalance($address: String!, $unit: Unit) {\n  xyo: balance(\n    contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    address: $address\n    unit: $unit\n  )\n}\n    "])));
/**
 * __useXyoBalanceQuery__
 *
 * To run a query within a React component, call `useXyoBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useXyoBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXyoBalanceQuery({
 *   variables: {
 *      address: // value for 'address'
 *      unit: // value for 'unit'
 *   },
 * });
 */
function useXyoBalanceQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.XyoBalanceDocument, options);
}
exports.useXyoBalanceQuery = useXyoBalanceQuery;
function useXyoBalanceLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.XyoBalanceDocument, options);
}
exports.useXyoBalanceLazyQuery = useXyoBalanceLazyQuery;
exports.BalancesDocument = client_1.gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    query Balances($address: String!, $unit: Unit) {\n  xyo: balance(\n    contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    address: $address\n    unit: $unit\n  )\n  ethereum: balance(address: $address, unit: $unit)\n}\n    "], ["\n    query Balances($address: String!, $unit: Unit) {\n  xyo: balance(\n    contractAddress: \"0x55296f69f40ea6d20e478533c15a6b08b654e758\"\n    address: $address\n    unit: $unit\n  )\n  ethereum: balance(address: $address, unit: $unit)\n}\n    "])));
/**
 * __useBalancesQuery__
 *
 * To run a query within a React component, call `useBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBalancesQuery({
 *   variables: {
 *      address: // value for 'address'
 *      unit: // value for 'unit'
 *   },
 * });
 */
function useBalancesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(exports.BalancesDocument, options);
}
exports.useBalancesQuery = useBalancesQuery;
function useBalancesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(exports.BalancesDocument, options);
}
exports.useBalancesLazyQuery = useBalancesLazyQuery;
exports.RemoveAddressDocument = client_1.gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    mutation RemoveAddress($id: String!) {\n  removeAddress(id: $id) {\n    ...VerifiedAddress\n  }\n}\n    ", ""], ["\n    mutation RemoveAddress($id: String!) {\n  removeAddress(id: $id) {\n    ...VerifiedAddress\n  }\n}\n    ", ""])), exports.VerifiedAddressFragmentDoc);
/**
 * __useRemoveAddressMutation__
 *
 * To run a mutation, you first call `useRemoveAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAddressMutation, { data, loading, error }] = useRemoveAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
function useRemoveAddressMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(exports.RemoveAddressDocument, options);
}
exports.useRemoveAddressMutation = useRemoveAddressMutation;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
//# sourceMappingURL=bindings.js.map